import { oaApi } from 'Api/axios'

/**
 * Realiza la asignación de sucursal para entrega a domicilio (delivery)
 * @param {Object} payload - Datos requeridos por el endpoint OA delivery
 * @returns {Promise<Object>} Respuesta del sistema OA
 */
export const postOrderAllocationDelivery = async payload => {
  const { data } = await oaApi.post('/mdl21/inventory/delivery', payload)
  return data
}

/**
 * Realiza la asignación de sucursal para pickup (recogida en tienda)
 * @param {Object} payload - Datos requeridos por el endpoint OA pickup
 * @returns {Promise<Object>} Respuesta del sistema OA
 */
export const postOrderAllocationPickup = async payload => {
  const { data } = await oaApi.post('/inventory/pickup', payload)
  return data
}
